import { useState } from 'react';
import { useNavigate } from 'react-router';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogTrigger,
  AlertDialogFooter,
  AlertDialogAction,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { resetEscrowOnboardingStep } from 'src/utils/escrowOnboardingLocalStorage';

type Props = {
  triggerText: React.ReactNode;
};

const AgreementReviewDialog = ({ triggerText }: Props) => {
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false);

  const navigate = useNavigate();
  const {
    softwareEscrow: { id },
  } = useSoftwareEscrow();

  const onSubmit = () => {
    resetEscrowOnboardingStep(id);
    navigate(`/software-escrows/${id}/agreement`);
  };

  return (
    <AlertDialog open={isAlertDialogOpen} onOpenChange={setIsAlertDialogOpen}>
      <AlertDialogTrigger asChild>
        <Button>{triggerText}</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Your escrow has been submitted and is now ready for review.</AlertDialogTitle>
          <AlertDialogDescription>
            Please check the agreement under the Agreement tab, review it, and approve it for signatures when ready.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction asChild onClick={onSubmit}>
            <Button className="w-full">Review agreement</Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AgreementReviewDialog;
